import { AbsgArrayHelper } from '@absg/angular-common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ItemPillExtendedView } from 'shared.root/models/Item-pill-extendedview.model';

@Component({
  selector: '[nc-station-pill-component]',
  templateUrl: './item-pill.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ItemPillComponent implements OnInit {

  @Input() isPillModalOpen: BehaviorSubject<boolean>;
  @Input() set pillItem(item: ItemPillExtendedView) {
    if (!AbsgArrayHelper.isNil(item)) {
      this.displayItem = item;
    }
  }

  @Output() closeModalEvent = new EventEmitter<boolean>();

  displayItem: ItemPillExtendedView;
  isPillModalOpenStatus = false;
  closeModal(): void {
    this.closeModalEvent.emit(false);
  }

  ngOnInit(): void {
    this.isPillModalOpen.subscribe(x => {
      this.isPillModalOpenStatus = x;
    });
  }
}
